export const SOCIAL_MATCHES_POLLING_INTERVAL_IN_MS = 60000
